import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import PublicRoutes from './components/PublicRoutes';
import RequireAuth from './components/RequireAuth';
import EulaAgreement from 'components/EulaAgreement/EulaAgreement';
import { useAuth } from 'contexts/AuthContext';
import { FeaturesProvider } from 'contexts/FeaturesContext';
import { OnboardingTourProvider } from 'contexts/OnboardingTourContext';
import { TicketsProvider } from 'contexts/TicketsContext';
import { UserProfileProvider } from 'contexts/UserProfileContext';
import { RoutePathsE } from 'declarations/enums/routes';
import LoginPage from 'pages/LoginPage/LoginPage';
import ProfilePage from 'pages/ProfilePage/ProfilePage';
import ReleasesPage from 'pages/ReleasesPage/ReleasesPage';
import TicketsPageLayout from 'pages/TicketsPage/components/TicketsPageLayout/TicketsPageLayout';
import TicketsPage from 'pages/TicketsPage/TicketsPage';

const AppRoutes: FC = () => {
  const { isUserLoggedIn } = useAuth();

  return (
    <Routes>
      {/* Public routes */}
      <Route
        path={RoutePathsE.LOGIN_PAGE}
        element={
          <PublicRoutes>
            <LoginPage />
          </PublicRoutes>
        }
      />

      {/* Private routes */}
      <Route
        element={
          <RequireAuth>
            <UserProfileProvider>
              <TicketsProvider>
                <OnboardingTourProvider>
                  <FeaturesProvider>
                    <EulaAgreement />
                    <TicketsPageLayout />
                  </FeaturesProvider>
                </OnboardingTourProvider>
              </TicketsProvider>
            </UserProfileProvider>
          </RequireAuth>
        }
      >
        <Route path={RoutePathsE.TICKETS_PAGE} element={<TicketsPage />} />
      </Route>
      <Route
        path={RoutePathsE.PROFILE_PAGE}
        element={
          <RequireAuth>
            <UserProfileProvider>
              <ProfilePage />
            </UserProfileProvider>
          </RequireAuth>
        }
      />
      <Route
        path={RoutePathsE.RELEASES_PAGE}
        element={
          <RequireAuth>
            <UserProfileProvider>
              <ReleasesPage />
            </UserProfileProvider>
          </RequireAuth>
        }
      />

      {/* Redirect if user tries to visit not defined route */}
      <Route
        path="*"
        element={
          <Navigate
            replace
            to={isUserLoggedIn ? RoutePathsE.TICKETS_PAGE : RoutePathsE.LOGIN_PAGE}
          />
        }
      />
    </Routes>
  );
};

export default AppRoutes;
